import { formatInTimeZone } from "date-fns-tz";
import { Card, Icon, Tooltip, Typography } from "@/components/atoms";
import { useProfile } from "@/hooks";
import { BookingDetails } from "@/redux/slices/booking/types";
import { DetailField } from "../../../../common/DetailField";

interface BookingTimeCardProps {
  booking: BookingDetails;
}

export const BookingTimeCard = ({ booking }: BookingTimeCardProps) => {
  const profile = useProfile();
  const { dates } = booking;

  const formatDate = (dateString: string, timezone: string, format: string) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }
      return formatInTimeZone(date, timezone, format);
    } catch (error) {
      return "Invalid date";
    }
  };

  return (
    <Card className="p-2.5">
      <DetailField
        leading={<Icon name="Clock" size="lg" className="text-neutral-dark-gray" />}
        label="Booking Time"
        value={
          <div className="flex items-center gap-2">
            <Typography variant="paragraph">
              {formatDate(dates.pickup, dates.timezone, profile.timeFormat)} ({dates.timezone.split("/")[1]})
            </Typography>
            {profile.timezone.name !== dates.timezone && (
              <Tooltip content={formatDate(dates.pickup, profile.timezone.name, `${profile.timeFormat} zzzz`)} placement="top">
                <Icon name="InfoCircle" className="inline-block translate-x-1 rotate-180 text-neutral-dark-gray" size="sm" />
              </Tooltip>
            )}
          </div>
        }
      />
    </Card>
  );
};
